import Vue from 'vue';
import Auth from '@js/plugins/auth';
import Unleash from '@js/plugins/unleash';

if (Unleash.hasFeature('ph_bir_reports')) {
    Vue.component('bir-reports-table', () => import('./bir-reports-table.vue'));
}
